// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c223869c","455":"f9b1e604","977":"ee675fc7"}[chunkId] + ".chunk.js";
};